const inputEvent = el => (e) => {
    format(el, e.target.value);
};

const format = (el, value) => {
    const userValue = parseFloat(value);
    if (isNaN(userValue)) {
        return;
    }
    el.value = (Math.round(userValue * 100) / 100).toFixed(2);
};

const updateIfNotActive = (el) => {
    if (el !== document.activeElement) {
        format(el, el.value);
    }
};

export default {
    bind(el) {
        updateIfNotActive(el);
        el.addEventListener('blur', inputEvent(el));
        el.step = 0.01;
    },
    update: updateIfNotActive,
};



// WEBPACK FOOTER //
// ./src/directives/TwoDecimalPlaces.js